var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3C1.3125 0 0 1.35938 0 3V15C0 16.6875 1.3125 18 3 18H21C22.6406 18 24 16.6875 24 15V3C24 1.35938 22.6406 0 21 0ZM3 2.25H21C21.375 2.25 21.75 2.625 21.75 3V4.07812L13.9219 10.5469C12.8438 11.4375 11.1094 11.4375 10.0312 10.5469L2.25 4.07812V3C2.25 2.625 2.57812 2.25 3 2.25ZM21 15.75H3C2.57812 15.75 2.25 15.4219 2.25 15V6.98438L8.625 12.3281C9.5625 13.0781 10.7344 13.5 12 13.5C13.2188 13.5 14.3906 13.0781 15.3281 12.3281L21.75 6.98438V15C21.75 15.4219 21.375 15.75 21 15.75Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.dbbb1f952ff651565aea982963430eb2.svg";
export { ForwardRef as ReactComponent };